const NodeJS = () => {
  return <h1>NodeJS  </h1>;
};

export default NodeJS;